export const AboutCSS = {

  about: {
    padding: "20px",
    margin: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  aboutPara: {
    maxWidth: "800px",
    textAlign: "justify",
    fontWeight: "600",
  },
};
